// Single source of truth for the app's warm navy/gold palette, in dark and light.
// Used by the dashboard, the shared ProjectCard and the projects list so the look
// stays identical everywhere.
export const getPalette = (theme) => {
  const dark = theme !== 'light';
  return dark ? {
    page: '#0F0F0F', card: '#1A1A1A', cardSubtle: '#26221C', chip: '#34302A',
    text: '#EDE7DC', text2: '#A8A196', muted: '#7A7368',
    border: 'rgba(212,165,116,0.22)', borderStrong: 'rgba(212,165,116,0.55)',
    gold: '#D4A574', goldBright: '#E7C98C', onGold: '#1A1206',
    goldGrad: 'linear-gradient(90deg,#C9A05E 0%,#E7C98C 50%,#C9A05E 100%)',
    shadow: '0 4px 22px rgba(0,0,0,0.5)', shadowHover: '0 12px 36px rgba(0,0,0,0.65)',
    brown: '#A67C52', success: '#4FA07A', warning: '#D08A4A', grey: '#9AA0A6', purple: '#8877AE', teal: '#4E9E90', danger: '#C0574E',
  } : {
    page: '#F6F3EC', card: '#FFFFFF', cardSubtle: '#F4F1EA', chip: '#EFEBE2',
    text: '#1A1611', text2: '#4A4034', muted: '#6B6255',
    border: 'rgba(139,115,85,0.30)', borderStrong: 'rgba(139,115,85,0.7)',
    gold: '#B8894C', goldBright: '#C9A05E', onGold: '#1A1206',
    goldGrad: 'linear-gradient(90deg,#C9A05E 0%,#E7C98C 50%,#C9A05E 100%)',
    shadow: '0 2px 12px rgba(60,45,25,0.08)', shadowHover: '0 12px 30px rgba(60,45,25,0.16)',
    brown: '#8B7355', success: '#3E8C68', warning: '#C07A38', grey: '#6B7280', purple: '#6F5F97', teal: '#3E8A7C', danger: '#B24A42',
  };
};

// Rotating interior cover photos used when a project has no uploaded cover yet.
export const COVERS = [
  'https://images.unsplash.com/photo-1648881806148-e5c51179c826?crop=entropy&cs=srgb&fm=jpg&w=600&q=70&ixlib=rb-4.1.0',
  'https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&w=600&q=70&ixlib=rb-4.1.0',
  'https://images.unsplash.com/photo-1611048267451-e6ed903d4a38?crop=entropy&cs=srgb&fm=jpg&w=600&q=70&ixlib=rb-4.1.0',
  'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?crop=entropy&cs=srgb&fm=jpg&w=600&q=70&ixlib=rb-4.1.0',
  'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&w=600&q=70&ixlib=rb-4.1.0',
];

// Same accent set the dashboard assigns to project cards, keyed stably per project.
export const PROJECT_ACCENTS = ['#CD853F', '#5F9EA0', '#8D6E63', '#4682B4', '#795548', '#5C6BC0', '#26A69A', '#FF7043'];
